import { api } from "./api";

export const track = (type, extra = {}) => {
  try {
    const p = new URLSearchParams(window.location.search);
    let source = (p.get("utm_source") || "").toLowerCase().slice(0, 40);
    if (!source && document.referrer) {
      try {
        const host = new URL(document.referrer).hostname.replace(/^www\./, "");
        source = host === "instagram.com" || host.endsWith(".instagram.com") ? "instagram" : host.split(".")[0];
      } catch {
        source = "";
      }
    }
    if (!source) source = "direct";
    api.post("/events", { type, path: window.location.pathname.slice(0, 200), source, ...extra }).catch(() => {});
  } catch {
    /* tracking must never break the app */
  }
};
